import ClientHistory from './ClientHistory';

export default ClientHistory;
